import tmhRequest from '@/config/tmhRequest'

export default {

    searchRefundRechargeOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundrechargeorder/searchrefundrechargeorder',
            method: 'post',
            params: data,
        })
    },

    searchRefundRechargeOrderCount: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundrechargeorder/searchrefundrechargeordercount',
            method: 'post',
            data: data,
        })
    },

    searchRefundRechargeOrderByPage: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundrechargeorder/searchrefundrechargeorderbypage',
            method: 'post',
            data: data,
        })
    },

    initRefundRechargeOrderByOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundrechargeorder/initrefundrechargeorderbyorder',
            method: 'post',
            params: data,
        })
    },

    createRefundRechargeOrderByOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundrechargeorder/createrefundrechargeorderbyorder',
            method: 'post',
            data: data,
        })
    },

    repairRefundRechargeOrder: function (data) {
        return tmhRequest({
            url: '/order/refundrechargeorder/repairrefundrechargeorder',
            method: 'post',
            params: data,
        })
    },

    refundNotify: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundrechargeorder/refundnotify',
            method: 'post',
            params: data,
        })
    },

    repairSettlementDetail: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundrechargeorder/repairsettlementdetail',
            method: 'post',
            params: data,
        })
    },

    repairEmployeePerformance: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundrechargeorder/repairemployeeperformance',
            method: 'post',
            params: data,
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/ispa/order/refundrechargeorder.js